import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ReactElement, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectAppUpdated, setDelayUpdateMoment } from './core.slice';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const delayValue = 5 * 60 * 1000;
export const UpdateNotifier: () => ReactElement = () => {
    const dispatch = useDispatch();
    const isUpdated = useSelector(selectAppUpdated);

    const reloadLater = useCallback(() => {
        dispatch(setDelayUpdateMoment(Date.now() + delayValue));
    }, [dispatch]);

    const reloadApp = useCallback(() => {
        window.location.reload();
    }, []);

    return (
        <Dialog
            open={isUpdated}
            onClose={() => reloadLater()}
            aria-labelledby='update-notifier-dialog-title'
            aria-describedby='update-notifier-dialog-description'
        >
            <DialogTitle id='update-notifier-dialog-title'>Application Updated</DialogTitle>
            <DialogContent>
                <DialogContentText id='update-notifier-dialog-description'>
                    Please reload the page to get the latest version of the application.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => reloadApp()} variant='contained' color='primary'>
                    Reload Application
                </Button>
                <Button onClick={() => reloadLater()} variant='contained' color='secondary'>
                    Reload Later
                </Button>
            </DialogActions>
        </Dialog>
    );
};
